/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1HIcon16Solid = forwardRef('ArrowDim1HIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.295 3.704c.44.44.44 1.152 0 1.591l-1.579 1.58h8.567l-1.579-1.58a1.125 1.125 0 1 1 1.591-1.59l2.793 2.792c.83.83.83 2.176 0 3.006l-2.793 2.793a1.125 1.125 0 1 1-1.59-1.591l1.58-1.58h-8.57l1.58 1.58a1.125 1.125 0 0 1-1.59 1.59L.91 9.504a2.125 2.125 0 0 1 0-3.006l2.793-2.792c.44-.44 1.152-.44 1.591 0Z" })));
});
